import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

export default function TextReveal({ text, className = "", delay = 0 }) {
    const prefersReducedMotion = useReducedMotion();
    const words = text.split(" ");

    const container = {
        hidden: { opacity: prefersReducedMotion ? 0 : 1 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: prefersReducedMotion ? 0 : 0.055,
                delayChildren: delay
            }
        }
    };

    const child = {
        hidden: prefersReducedMotion
            ? { opacity: 0 }
            : { opacity: 0, y: "0.45em" },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] }
        }
    };

    return (
        // A span (not a div) so this stays valid inside heading elements.
        <motion.span
            variants={container}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className={`inline-flex flex-wrap ${className}`}
        >
            {words.map((word, index) => (
                <span key={index} className="inline-block overflow-hidden pb-[0.06em]">
                    <motion.span variants={child} className="inline-block pr-[0.25em]">
                        {word}
                    </motion.span>
                </span>
            ))}
        </motion.span>
    );
}
